export const GF_USER = [
    {value:1 , label: "Một Em"},
    {value:2 , label: "Hai Em"},
    {value:3 , label: "Ba Em"},
    {value:4 , label: "Bốn Em"},
    {value:5 , label: "Năm Em"},
    {value:6 , label: "Không Có 0 Em Đâu"},

]